export interface CompletionResult {
  criticalPct: number;
  recommendedPct: number;
  overallPct: number;
  criticalFilled: number;
  criticalTotal: number;
  recommendedFilled: number;
  recommendedTotal: number;
}

export function computeStandCompletion(data: Record<string, any>): CompletionResult {
  const critical: boolean[] = [
    typeof data.name === 'string' && data.name.length > 2,
    typeof data.contactPerson === 'string' && data.contactPerson.length > 2,
    typeof data.logo === 'string' && data.logo.length > 0,
    Array.isArray(data.galleryUrls) && data.galleryUrls.length >= 1,
    typeof data.standType === 'string' && data.standType.length > 0,
    typeof data.region === 'string' && data.region.length > 0,
  ];

  // Dimensions et documents légaux retirés du parcours de création (la plupart
  // des exposants n'ont pas leurs documents sous la main à l'inscription) —
  // ils ne doivent donc plus être CRITIQUES (poids 70%) sous peine de plafonner
  // tout le monde. Documents restent "recommandés" : encore utiles au dossier
  // (matchScore orga) mais jamais bloquants.
  const recommended: boolean[] = [
    typeof data.bannerUrl === 'string' && data.bannerUrl.length > 0,
    typeof data.brandStory === 'string' && data.brandStory.length > 20,
    (typeof data.instagram === 'string' && data.instagram.length > 0) ||
      (typeof data.tiktok === 'string' && data.tiktok.length > 0),
    (Number(data.foundingYear) || 0) > 1900,
    typeof data.videoUrl === 'string' && data.videoUrl.length > 0,
    typeof data.pastFestivals === 'string' && data.pastFestivals.length > 5,
    typeof data.revenueRange === 'string' && data.revenueRange.length > 0,
    typeof data.maxDailyVolume === 'string' && data.maxDailyVolume.length > 0,
    typeof data.priceRange === 'string' && data.priceRange.length > 0,
    typeof data.insuranceUrl === 'string' && data.insuranceUrl.length > 0,
    typeof data.kbisUrl === 'string' && data.kbisUrl.length > 0,
    typeof data.sanitaryUrl === 'string' && data.sanitaryUrl.length > 0,
  ];

  const criticalFilled = critical.filter(Boolean).length;
  const recommendedFilled = recommended.filter(Boolean).length;
  const criticalTotal = critical.length;
  const recommendedTotal = recommended.length;

  const criticalPct = Math.round((criticalFilled / criticalTotal) * 100);
  const recommendedPct = Math.round((recommendedFilled / recommendedTotal) * 100);
  const overallPct = Math.round(criticalPct * 0.7 + recommendedPct * 0.3);

  return {
    criticalPct,
    recommendedPct,
    overallPct,
    criticalFilled,
    criticalTotal,
    recommendedFilled,
    recommendedTotal,
  };
}

export function computeFestivalCompletion(data: Record<string, any>): CompletionResult {
  const b = data.branding || {};

  const critical: boolean[] = [
    typeof data.name === 'string' && data.name.length > 2,
    typeof data.location === 'string' && data.location.length > 2,
    typeof data.startDate === 'string' && data.startDate.length > 0,
    typeof data.endDate === 'string' && data.endDate.length > 0,
    Array.isArray(data.musicStyles) && data.musicStyles.length > 0,
    typeof b.coverImage === 'string' && b.coverImage.length > 0,
    Array.isArray(data.standTypes) && data.standTypes.length > 0,
    (Number(data.capacity) || 0) > 0 || (Number(data.dailyPax) || 0) > 0,
  ];

  const recommended: boolean[] = [
    typeof b.description === 'string' && b.description.length > 20,
    !!(b.socials && Object.values(b.socials).some((v) => typeof v === 'string' && v.length > 0)),
    typeof data.editionNumber !== 'undefined' && data.editionNumber !== '',
    typeof data.pastAudience === 'string' && data.pastAudience.length > 0,
    typeof data.historyDescription === 'string' && data.historyDescription.length > 10,
    Array.isArray(b.gallery) && b.gallery.length >= 1,
    typeof b.logoImage === 'string' && b.logoImage.length > 0,
    typeof data.about === 'string' && data.about.length > 10,
    typeof data.ticketingUrl === 'string' && data.ticketingUrl.length > 0,
    Array.isArray(data.allowedSlots) && data.allowedSlots.length > 0,
    typeof data.expectedPriceRange === 'string' && data.expectedPriceRange.length > 0,
  ];

  const criticalFilled = critical.filter(Boolean).length;
  const recommendedFilled = recommended.filter(Boolean).length;
  const criticalTotal = critical.length;
  const recommendedTotal = recommended.length;

  const criticalPct = Math.round((criticalFilled / criticalTotal) * 100);
  const recommendedPct = Math.round((recommendedFilled / recommendedTotal) * 100);
  const overallPct = Math.round(criticalPct * 0.7 + recommendedPct * 0.3);

  return {
    criticalPct,
    recommendedPct,
    overallPct,
    criticalFilled,
    criticalTotal,
    recommendedFilled,
    recommendedTotal,
  };
}
